// extracted by mini-css-extract-plugin
module.exports = {"link":"ItemHasApplicationsErrorNotification_link__XV6Jo"};